import { getGraphQLClientInsights } from '../../../utilities/graphql';
import * as loggerx from '../../../utilities/loggerx';
import type { VideoSessionData } from './video-session';
import { getAppSource } from 'utilities/device';

import VideoView from '../../../utilities/video-session/engagementInsightsView.graphql';

interface Event {
  sessionId: string;
  videoId: string;
  appSource?: string;
}

async function markAsViewed(sessionData?: VideoSessionData): Promise<unknown> {
  if (!sessionData) {
    return;
  }

  const event = {
    sessionId: sessionData.id,
    videoId: sessionData.videoId,
    appSource: getAppSource(),
  };

  loggerx.addCrumb({
    message: 'video view',
  });

  try {
    // TODO: VV: Password required - after we implement password unlock for fresh player
    const data = await sendMutation(VideoView, event);

    loggerx.debug('video view response', { data });

    return data;
  } catch (err) {
    loggerx.error(err, { videoId: sessionData.videoId, variables: event });
  }
}

function sendMutation(mutation: unknown, event: Event) {
  const client = getGraphQLClientInsights();

  return client.mutate({
    mutation,
    variables: { event },
  });
}

export default markAsViewed;
